import React, { useEffect } from 'react';
import Chart from "react-apexcharts";
import { ChartStyles } from "../../ui/charts/ChartStyles.jsx";
import {useTranslation} from "react-i18next";


export default function LineChartRating({ data, width = '100%', height = '320px', className = '' }) {
    const { t} = useTranslation();

    const chartStyles = {
        ...ChartStyles,
        chart: {
            ...ChartStyles.chart,
            id: "pq-insights-chart-" + Math.round((Math.random() * 1000000)),
            type: "area",
        },
        fill: {
            ...ChartStyles.fill,
            type: ['solid'],
        },
        stroke: {
            curve: ['smooth'],
            width: [2],
        },
        xaxis: {
            ...ChartStyles.xaxis,
            type: 'datetime',
        },
        yaxis: {
            ...ChartStyles.yaxis,
            tickAmount: 5,
            min: 0,
            max: 5,
            decimalsInFloat: 1,
            labels: {
                ...ChartStyles.yaxis.labels,
                formatter: function (val) {
                    return val.toFixed(0);
                },
            },
        },
        tooltip: {
            y: {
                formatter: (value) => value.toFixed(1)
            }
        }
    };
    const [dataSeries, setDataSeries] = React.useState({
        rating: {
            name: t('Rating'),
            color: "#6D2AF6",
            type: 'line',
            zIndex: 30,
            data: []
        },
    });
    const [dataSeriesAsArray, setDataSeriesAsArray] = React.useState([]);


    useEffect(() => {
        if (!data) return;

        let dataSeriesNew = {
            rating: { ...dataSeries.rating, data: data.rating ? [...data.rating] : [] },
        };

        Object.keys(data).forEach((key, index) => {
            dataSeriesNew[key].data = data[key];
        });

        setDataSeries(dataSeriesNew);
        setDataSeriesAsArray([dataSeriesNew.rating]);
    }, [data]);


    return dataSeries.rating.data && dataSeries.rating.data.length ? (
        <Chart type="area" options={chartStyles} series={dataSeriesAsArray} width={width} height={height} className={className} />
    ) : '';
}